import React from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';

const PickupBanksPopup = (props) => {
    return (
        <ComplexPopup withoutButton popupRef={props.popupRef}>
            <DangerouslyHtml dangerouslyHtml={props.pickupBanks} />
        </ComplexPopup>
    );
};
const mapStateToProps = (state) => {
    return {
        pickupBanks: state.messages.pageMessages.pickupBanks,
    };
};
export default connect(mapStateToProps)(PickupBanksPopup);
